import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-general-response',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './general-response.component.html',
  styleUrl: './general-response.component.css'
})
export class GeneralResponseComponent {
  rfiData = [
    { label: 'Number', value: '1' },
    { label: 'Due Date', value: '7/01/2025' },
    { label: 'RFI Manager', value: 'Ethan Williams' },
    { label: 'Status', value: 'Open' },
    { label: 'Received From', value: 'Crestline Engineering Group' },
    { label: 'Assignees', value: 'Mia Taylor' },
    { label: 'Distribution List', value: 'Evelyn Scott' },
    { label: 'Ball in Court', value: 'Mia Taylor' },
    { label: 'Responsible Contractor', value: 'Sterling Structural Solutions' },
    { label: 'Spec Section', value: '26 20 00 – Electrical Distribution' },
    { label: 'Location', value: 'Level 1> North Wing >135 Executive office' },
    { label: 'Created By', value: 'Pat Project Manager' },
    { label: 'RFI Stage', value: '......' },
    { label: 'Drawing Number', value: 'A111' },
    { label: 'Cost Code', value: '01-011 – Project Engineer' },
    { label: 'Date Initiated', value: 'Jan 01, 2025' },
    { label: 'Schedule Impact', value: 'Yes (5 Days)' },
    { label: 'Cost Impact', value: '......' },
    { label: 'Reference', value: '......' },
    { label: 'Private', value: '' }
  ];
}
